import {React, useState,useEffect} from 'react';
import {Col, Modal, ModalBody, ModalHeader, Row} from 'reactstrap'
import AxiosURL from '../../ApiService/AxiosURL';


function Header()
{
    const [modal, setModal] = useState(false);
    const [millName, setMillName] = useState('');
    const [conatctPerson, setconatctPerson] = useState('');
    const [phone, setmobile] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [district, setDistrict] = useState('');
    const [village, setvillage] = useState('');
    // console.log(village);
    const handleSubmit = e =>{
        e.preventDefault();
        AxiosURL.post("farmers/add_mill",{millName, conatctPerson, phone, email,password, district, village})
        .then(response => {
            alert("MIll successfully Added");
            // console.log(response);
            window.location.reload();
        }).catch((error) => {
            console.log(error);
            // setErrormsg(error.data.message);
            alert("Something went wrong" );
        });
    }

    var RoleID = localStorage.getItem('role_id');
    
    return (
     <>

        <nav className="navbar navbar-expand  navbar-light navbar-bg">
        <div className="navbar-collapse collapse">
            <span>
                {RoleID==2 ?
        <a href="http://castor_analytics.solidaridadasia.com/api/graph/" target="_blank" rel="noreferrer" className='analytics_anch'>
            {/* <button className='btn btn-info analytics_header' >Analytics Dashboard</button> */}
            <button type="button" className="btn btn-warning btn-arrow-right color shadow"> &nbsp; Analytical Dashboard &nbsp;</button>
            </a>
            : ''}
            </span>
            <span>
                {RoleID==2 ?
        //  <button className='btn btn-info addmillButton' onClick={() =>setModal(true)}  >Add Mill</button>
        <button type="button" className="btn btn-warning btn-arrow-right color shadow" onClick={() =>setModal(true)}>&nbsp;Add Mill &nbsp;</button>
            : ''}
            </span>
            <ul className="navbar-nav navbar-align">

                <li className="nav-item dropdown">
                    <a className="nav-icon dropdown-toggle d-inline-block d-sm-none" href="#" data-bs-toggle="dropdown">
        <i className="align-middle" data-feather="settings"></i>
      </a>
      {/* <a href="http://castor_analytics.solidaridadasia.com/api/graph/" target="_blank" className='analytics'><button className='btn btn-info' >Analytics Dashboard</button></a> */}
      <span > <img src="images/solidaridad_logo.png" className='comapnyLogo'  height="40px" alt="company-Logo"  /></span>
             </li>
            </ul>
        </div>
    </nav>

        <Modal 
        isOpen={modal}
        toggle={() => setModal(!modal)}>
            <ModalHeader toggle={() => setModal(!modal)}>
                Add Mill
            </ModalHeader>
            <ModalBody>
                <form  onSubmit={handleSubmit}>
                    <Row>
                        <Col lg={12}>
                        <div>
                            <input type="text" className="form-control" id="millName_id"  placeholder=" Enter Mill name" onChange={e=>setMillName(e.target.value)} />
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                        <div>
                            <input type="text" className="form-control mt-3" id="contact_person_id"  placeholder="Enter contact person name" onChange={e=>setconatctPerson(e.target.value)} />
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                        <div>
                            <input type="text" className="form-control mt-3" id="mobile_id"  placeholder=" Enter mobile number" onChange={e=>setmobile(e.target.value)} />
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                        <div>
                            <input type="email" className="form-control mt-3" id="email_id"  placeholder="Enter contact email" onChange={e=>setEmail(e.target.value)} />
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                        <div>
                            <input type="password" className="form-control mt-3" id="contact_password_id"  placeholder="Enter password" onChange={e=>setPassword(e.target.value)} />
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                        <div>
                            <input type="text" className="form-control mt-3" id="district_id"  placeholder=" Enter district" onChange={e=>setDistrict(e.target.value)} />
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                        <div>
                            <input type="text" className="form-control mt-3" id="village_id"  placeholder="Enter village" onChange={e=>setvillage(e.target.value)} />
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4}>
                        <div>
                            {/* <button className='btn btn-success mt-4' style={{fontSize:'1.5rem', width:'10rem'}}>Save</button> */}
                            <input type="submit" className='btn  mt-4'style={{fontSize:'1.5rem', width:'10rem', backgroundColor:'#FDC315'}}/>
                        </div>
                        </Col>
                    </Row>
                </form>
            </ModalBody>
        </Modal>
     </>
    ) 
}
export default Header;

